import { render, staticRenderFns } from "./PackagesSellTable.vue?vue&type=template&id=4b9e7d37&scoped=true&"
import script from "./PackagesSellTable.vue?vue&type=script&lang=js&"
export * from "./PackagesSellTable.vue?vue&type=script&lang=js&"
import style0 from "./PackagesSellTable.vue?vue&type=style&index=0&id=4b9e7d37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9e7d37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VDataTable,VSpacer})
